<template lang="pug">
  v-layout(row wrap)
    v-flex(v-for="category in categories")
      v-btn(@click="$emit('setCategory',category)" flat) {{category}}

</template>
<script>
export default {
  name: 'Categories',
  computed:{
    categories() {
      return this.$store.state.categories
    }
  }
}
</script>

